import { getCurrentEnvironment } from '../../config/endpoints';

// Safe fallback configuration when no environment is loaded
// Uses proxy when authServiceEndpoint is empty (requests go through React dev server proxy)
const FALLBACK_CONFIG = {
  name: 'Local Development',
  description: 'Local development server (using proxy)',
  authServiceEndpoint: '',
  apiConfig: {
    API_PREFIX: '/admin-api/v1',
    ADMIN_API_KEY: ''
  },
  theme: {
    primaryColor: '#4361EE',
    backgroundColor: '#f8f9fa'
  }
};

// Get current environment configuration
export const getEnvironmentConfig = () => {
  // First check for custom environment in localStorage
  const customEnvStr = localStorage.getItem('custom-env-config');
  if (customEnvStr) {
    try {
      const customEnv = JSON.parse(customEnvStr);
      if (customEnv?.authServiceEndpoint) {
        return customEnv;
      }
    } catch (e) {
      console.warn('Failed to parse custom env config:', e);
    }
  }
  
  const config = getCurrentEnvironment();
  if (!config) {
    return FALLBACK_CONFIG;
  }
  return config;
};

// Set environment configuration (for login page configuration)
export const setEnvironmentConfig = (endpoint) => {
  const newConfig = {
    name: 'Custom Environment',
    description: 'User configured environment',
    authServiceEndpoint: endpoint,
    apiConfig: {
      API_PREFIX: '/admin-api/v1',
      ADMIN_API_KEY: ''
    },
    theme: {
      primaryColor: '#4361EE',
      backgroundColor: '#f8f9fa'
    }
  };
  
  // Store in localStorage for persistence
  localStorage.setItem('custom-env-config', JSON.stringify(newConfig));
  console.log('Environment configuration saved:', endpoint);
  
  return newConfig;
};

// Get API prefix - function instead of static value
export const getApiPrefix = () => {
  const config = getEnvironmentConfig();
  return config?.apiConfig?.API_PREFIX || '/admin-api/v1';
};

// Legacy export for backward compatibility (now a function)
const API_PREFIX = getApiPrefix();

// Log configuration during initialization (for debugging)
const logConfig = () => {
  const config = getEnvironmentConfig();
  if (!config) {
    console.log('No environment configured yet - waiting for environment file to be loaded');
    return;
  }
  console.log('API Configuration:', {
    ENVIRONMENT: config.name,
    AUTH_SERVICE: config.authServiceEndpoint,
    ADMIN_API_TOKEN: config.apiConfig?.ADMIN_API_KEY ? 'exists' : 'missing',
    API_PREFIX,
  });
};

// Listen for environment changes and update configuration
export const setupEnvironmentListener = (onEnvironmentChange) => {
  window.addEventListener('environment-changed', (event) => {
    console.log('Environment changed, updating API configuration:', event.detail);
    
    // Clear stored tokens and endpoints for the new environment
    localStorage.removeItem('admin-token');
    localStorage.removeItem('admin-session');
    localStorage.removeItem('available-endpoints');
    localStorage.removeItem('selected-endpoint');
    
    // Call the callback to reset dynamic endpoints
    if (onEnvironmentChange) {
      onEnvironmentChange();
    }
    
    // Log new configuration
    const config = getEnvironmentConfig();
    if (config) {
      console.log('New API Configuration:', {
        ENVIRONMENT: config.name,
        AUTH_SERVICE: config.authServiceEndpoint,
        ADMIN_API_TOKEN: config.apiConfig?.ADMIN_API_KEY ? 'exists' : 'missing',
        API_PREFIX: config.apiConfig?.API_PREFIX,
      });
    }
  });
};

// Log configuration after a short delay to allow environment to load
setTimeout(logConfig, 100);

// Re-export API_PREFIX for backward compatibility
export { API_PREFIX }; 